import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { media } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { Feature } from '../../components/Feature/Feature.js';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionFeature = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
  var background = _a.background,
    theme = _a.theme;
  return background === 'sand' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0;
});
var FeaturesContainer = styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    list-style: none;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    gap: ", ";\n    list-style: none;\n    flex-direction: column;\n\n    ", "\n\n    ", "\n  "])), theme.spacing[12], media.greaterThan('s')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      flex-direction: row;\n      word-break: break-word;\n      word-wrap: break-word;\n      hyphens: auto;\n    "], ["\n      flex-direction: row;\n      word-break: break-word;\n      word-wrap: break-word;\n      hyphens: auto;\n    "]))), getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  }));
});
var SectionFeature = function (_a) {
  var features = _a.features,
    name = _a.name,
    reference = _a.reference,
    background = _a.background;
  return jsx(StyledSectionFeature, {
    name: name,
    reference: reference,
    background: background,
    children: jsx(FeaturesContainer, {
      children: features.map(function (feature, index) {
        return jsx(Feature, __assign({}, feature, {
          background: background
        }), feature.title || index);
      })
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { SectionFeature, StyledSectionFeature };
//# sourceMappingURL=SectionFeature.js.map
